<template>
  <div class="after_optin relative">
    <el-tabs v-model="afterOptInActiveTab" class="demo-tabs" @tab-click="afterOptInChangeTab">
      <el-tab-pane v-for="tab in dynamicTabs" :key="tab.name" :label="tab.label" :name="tab.name">
        <component :is="tab.component" v-bind="tab.props" />
      </el-tab-pane>
    </el-tabs>

    <div class="top_left_component">
      <div>
        <el-select v-model="selectedAccount" :placeholder="'Select'">
          <el-option
            v-for="item in activeAccounts"
            :key="item.mt4Account"
            :label="item.mt4Account"
            :value="item.mt4Account"
          >
          </el-option
        ></el-select>
      </div>
      <div class="text-blueG0 cursor-pointer" @click="handleOptOut()">
        {{ $t('promotion.fundsGrowthPromotion.button.optOut') }}
      </div>
    </div>

    <div class="flex justify-center">
      <el-button
        class="mt-6 blue_button fgp_blue_button disabled:border-[#cdcfd3]! disabled:bg-transparent! rtl:mr-0"
        @click="handleOptAdditional()"
      >
        {{ $t('promotion.fundsGrowthPromotion.button.join') }}
      </el-button>
    </div>

    <OptInAdditionalModal
      :campaignId="campaignId"
      :optInAdditionalModalVisible.sync="optInAdditionalModalVisible"
      :redeemableAccounts="redeemableAccounts"
      @optInAdditionalSuccess="optInAdditionalSuccess"
    ></OptInAdditionalModal>
    <CongratulationModal
      :congratulationModalVisible.sync="congratulationModalVisible"
      :tncLink="tncLink"
    ></CongratulationModal>

    <OptOutModal
      :campaignId="campaignId"
      :optOutModalModalVisible.sync="optOutModalModalVisible"
      :activeAccounts="activeAccounts"
    ></OptOutModal>
  </div>
</template>

<script>
import WeeklySummary from '@/components/fundsGrowthPromotion/WeeklySummary.vue';
import RewardSummary from '@/components/fundsGrowthPromotion/RewardSummary.vue';
import OptInAdditionalModal from './OptInAdditionalModal.vue';
import OptOutModal from './OptOutModal.vue';
import CongratulationModal from './CongratulationModal.vue';

export default {
  name: 'fgpAfterOptIn',
  components: {
    WeeklySummary,
    RewardSummary,
    OptInAdditionalModal,
    OptOutModal,
    CongratulationModal
  },
  props: {
    campaignId: Number,
    optIn: Boolean,
    activeAccounts: Array,
    redeemableAccounts: Array,
    tncLink: String
  },

  data() {
    return {
      activeTab: 'history',
      afterOptInActiveTab: 'weeklySummary',
      selectedAccount: undefined,
      optInAdditionalModalVisible: false,
      optOutModalModalVisible: false,
      congratulationModalVisible: false
    };
  },
  mounted() {
    if (this.activeAccounts.length > 0) this.selectedAccount = this.activeAccounts[0].mt4Account;
  },
  watch: {
    activeAccounts(acc) {
      if (acc.length) {
        this.selectedAccount = acc[0].mt4Account;
      }
    }
  },
  computed: {
    isRTL() {
      return document.body.dir === 'rtl';
    },
    // to dynamically handle rtl cases
    dynamicTabs() {
      const tabs = [
        {
          label: this.$t('promotion.fundsGrowthPromotion.weeklySummary.title'),
          name: 'weeklySummary',
          component: 'WeeklySummary',
          props: {
            selectedAccount: this.selectedAccount,
            activeAccounts: this.activeAccounts,
            tncLink: this.tncLink
          }
        },
        {
          label: this.$t('promotion.fundsGrowthPromotion.rewardSummary.title'),
          name: 'rewardSummary',
          component: 'RewardSummary',
          props: {
            selectedAccount: this.selectedAccount,
            activeAccounts: this.activeAccounts,
            campaignId: this.campaignId,
            tncLink: this.tncLink
          }
        }
      ];

      return this.isRTL ? tabs.slice().reverse() : tabs;
    }
  },
  methods: {
    afterOptInChangeTab(tab) {
      this.afterOptInActiveTab = tab.name;
    },
    handleOptAdditional() {
      this.optInAdditionalModalVisible = true;
    },
    handleOptOut() {
      this.optOutModalModalVisible = true;
    },
    optInAdditionalSuccess() {
      this.congratulationModalVisible = true;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/pages/fundsGrowthPromotion.scss';
</style>
